import { blossom, branch, bud, drift, leaf, petal } from '../motifs';
import { M } from '../palette';
import { registerPlate } from '../registry';

const GOLDEN = ['#fff0a0', '#f4c43a', '#b8841c'] as const;
const LEAF = ['#a8c060', '#6a8a30', '#3e5a1c'] as const;

/** 19 ร่วงหล่น: the falling-flowers plate, brown lacquer with golden blossoms shedding petals. */
registerPlate({
  id: 'falling-flowers',
  name: 'ร่วงหล่น',
  ground: ['#5e3e22', '#3e2614', '#281810'],
  trim: M.gold,
  text: { fill: ['#ffe9a0', '#f0b040'], line: '#140a04' },
  inset: [14, 13],
  front(p, f) {
    branch(
      p,
      [
        [f.x - 6, f.y - 2],
        [f.x + 3, f.y - 4],
        [f.x + 12, f.y - 2],
      ],
      1.4,
      0.6,
    );
    branch(
      p,
      [
        [f.r + 6, f.b + 1],
        [f.r - 3, f.b - 4],
        [f.r - 9, f.b - 2],
      ],
      1.4,
      0.6,
    );
    leaf(p, f.x + 6, f.y - 4, -2.2, 5, 2.2, LEAF);
    leaf(p, f.r - 5, f.b - 4, 0.6, 5, 2.2, LEAF);
    for (const [x, y, r] of [
      [f.x - 2, f.y + 1, 4.7],
      [f.x + 4, f.y - 4, 3.9],
      [f.x + 11, f.y - 3, 3.4],
      [f.x - 1, f.b - 3, 3.9],
      [f.r - 1, f.b - 4, 4.7],
      [f.r + 3, f.y + 4, 3.9],
      [f.r - 7, f.b - 1, 3.4],
    ] as const)
      blossom(p, x, y, r, GOLDEN, M.redLo);
    bud(p, f.x + 14, f.y - 4, GOLDEN);
  },
  motion: {
    sprites: { petal: { w: 2, h: 2, draw: (p) => petal(p, 0, 0, GOLDEN) } },
    play(a, t, f) {
      drift(a, 'petal', t, 3, f.x - 4, 16, f.y - 2, f.b + 11, { speed: 0.26, slant: 4 });
      drift(a, 'petal', t, 2, f.r - 8, 10, f.y + 2, f.b + 10, { speed: 0.22, seed: 3 });
    },
  },
});
